module.exports = __webpack_public_path__ + "static/media/video.24c4fa89.svg";